import { Sheet } from '../ui/Sheet'
import { LegalBody } from './LegalBody'
import type { Doc } from './documents'

/**
 * One legal document, on screen — the in-app half of what the App Store requires
 * (guideline 5.1.1(i): the privacy policy must be reachable INSIDE the app, not only
 * linked from App Store Connect). The words and their rendering live in LegalBody,
 * shared with the public page (LegalPage) so the two can never disagree.
 */
export function LegalSheet({ doc, onClose }: { doc: Doc; onClose: () => void }) {
  return (
    <Sheet title={doc.title} onClose={onClose} className="legal-sheet">
      <LegalBody doc={doc} />
    </Sheet>
  )
}
